import * as warnings from "./core/deprecated_warnings";
import * as base from "./core/gantt";


const gantt = (window as any).gantt = base();
warnings(gantt);